import React, { FC, ReactNode } from 'react';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import { UIButton } from '../ui';

import { DatePickerMode } from './DatePicker.types';
import { getTimeDropdownOptions } from './utils';

export interface DatePickerContentProps {
  onClear?: () => void;
  onApply?: () => void;
  isApplyDisabled?: boolean;
  children?: ReactNode;
  className?: string;
  fromValue?: string;
  toValue?: string;
  shouldDisplayTime?: boolean;
  onOptionChange?: (time: string) => void;
  onFromTimeChange?: (time: string) => void;
  onToTimeChange?: (time: string) => void;
  displayInUTC?: boolean;
  mode?: DatePickerMode;
}

const DatePickerContent: FC<DatePickerContentProps> = ({
  onClear,
  onApply,
  isApplyDisabled = false,
  children,
  className,
  fromValue,
  toValue,
  shouldDisplayTime,
  onOptionChange,
  onFromTimeChange,
  onToTimeChange,
  displayInUTC,
  mode = DatePickerMode.SINGLE,
}) => {
  const hasActions = !!onClear || !!onApply;
  const TIME_OPTIONS = getTimeDropdownOptions(15, displayInUTC);

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {shouldDisplayTime && (
        <div className="flex gap-2">
          <InputSelectDropdown
            label="From"
            buttonDataTestId="scheduleFromHourBtn"
            listDataTestId="scheduleFromHourList"
            options={TIME_OPTIONS}
            defaultSelected={TIME_OPTIONS.find(
              (option) => option.value === fromValue
            )}
            onOptionChange={
              mode === DatePickerMode.RANGE ? onFromTimeChange : onOptionChange
            }
          />
          {mode === DatePickerMode.RANGE && (
            <InputSelectDropdown
              label="To"
              buttonDataTestId="scheduleToHourBtn"
              listDataTestId="scheduleToHourList"
              options={TIME_OPTIONS}
              defaultSelected={
                TIME_OPTIONS.find((option) => option.value === toValue) ||
                TIME_OPTIONS.find((option) => option.value === fromValue) ||
                TIME_OPTIONS.find((option) => option.value === '00:00')
              }
              onOptionChange={onToTimeChange}
            />
          )}
        </div>
      )}

      {children}

      {hasActions && (
        <div className="flex justify-between bg-base-background">
          {onClear && (
            <UIButton
              variant="link"
              onClick={onClear}
              className="text-base-foreground hover:text-base-primary underline"
            >
              Clear
            </UIButton>
          )}
          {onApply && (
            <UIButton
              variant="outline"
              onClick={onApply}
              className="ml-auto rounded-md border border-base-input bg-base-background text-base-foreground hover:bg-base-accent"
              disabled={isApplyDisabled}
            >
              Apply
            </UIButton>
          )}
        </div>
      )}
    </div>
  );
};

export default DatePickerContent;
